import { Upload } from "lucide-react";
import { cn } from "@/lib/utils";
import { buttonVariants } from "./button";

// A <label> wearing the button's classes, with the real file input stretched
// over it at zero opacity — a plain <button> cannot open a file picker.
export function FileButton({
  label,
  accept,
  onFile,
}: {
  label: string;
  accept?: string;
  onFile: (file: File) => void;
}) {
  return (
    <label className={cn(buttonVariants({ variant: "outline" }), "relative overflow-hidden")}>
      <Upload /> {label}
      <input
        type="file"
        accept={accept}
        className="absolute inset-0 cursor-pointer opacity-0"
        onChange={(event) => {
          const file = event.target.files?.[0];
          if (file) onFile(file);
          event.target.value = "";
        }}
      />
    </label>
  );
}
